import { useEffect } from 'react';
import { useTheme } from 'next-themes';
import { useUserPreferences } from './useUserPreferences';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Syncs theme preference between database and next-themes
 * Loads user's saved theme on login and keeps them in sync
 */
export function useThemeSync() {
  const { setTheme } = useTheme();
  const { user, loading } = useAuth(); // Add loading state
  const { preferences, isLoading } = useUserPreferences();

  useEffect(() => {
    // Only sync theme if auth is loaded, user is logged in, and preferences are loaded
    if (!loading && user && !isLoading && preferences.theme) {
      setTheme(preferences.theme);
    }
  }, [loading, user, preferences.theme, isLoading, setTheme]);
}